// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-23d79cfe]:root{--light_text_color:#666}.footer__copyright--center[data-v-23d79cfe]{text-align:center}.footer__copyright-title[data-v-23d79cfe]{color:#323236;font-weight:700;font-size:14px;line-height:17px;letter-spacing:.01em}.footer__copyright-text[data-v-23d79cfe]{color:#323236;font-size:11px;line-height:14px;letter-spacing:.01em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
